import { CheckCircle } from 'lucide-react';
import { Link } from 'react-router-dom';
import SEOHead from '../components/SEOHead';
import { PAGE_SEO } from '../seo';

export default function SetupComplete() {
  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <SEOHead page={PAGE_SEO.setup} />
      <div className="max-w-md w-full animate-slideUp">
        <div className="bg-white rounded-2xl shadow-rhythmic-xl p-8 text-center">
          <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <CheckCircle className="w-10 h-10 text-green-500" />
          </div>

          <h1 className="text-2xl font-display font-bold text-pb-orange mb-2">
            All Done!
          </h1>
          <p className="text-pb-gray-600 mb-8">
            PartnerBuddy is ready to use in your Slack workspace.
          </p>

          <div className="bg-pb-gray-50 rounded-xl p-4 text-left mb-6">
            <p className="text-sm text-pb-gray-700">
              Try it out by mentioning <code className="bg-white px-2 py-0.5 rounded border">@PartnerBuddy</code> in
              any allowed channel.
            </p>
          </div>

          <Link
            to="/"
            className="inline-flex items-center px-6 py-3 bg-pb-orange text-white rounded-lg font-semibold hover:bg-pb-orange-dark hover:shadow-lg transition-all"
          >
            Return Home
          </Link>
        </div>
      </div>
    </div>
  );
}
